import { render } from "./GiftShop.vue?vue&type=template&id=6cc44647"
import script from "./GiftShop.vue?vue&type=script&lang=js"
export * from "./GiftShop.vue?vue&type=script&lang=js"

import "./GiftShop.vue?vue&type=style&index=0&id=6cc44647&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__